// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3121":"847275d57d7d9047","8661":"52048b9feb1d83b0"}[chunkId] + ".css";
};